// import React, { useState } from "react";
// import { Search, Plus, BookOpen, Clock, ChevronLeft, ChevronRight, CheckCircle2 } from "lucide-react";

// // Static Data for Courses
// const COURSES_DATA = [
//   {
//     id: 1,
//     title: "Sports Safety & First Aid",
//     category: "Safety",
//     lessons: 8,
//     duration: "45 mins",
//     badge: "Mandatory",
//     badgeColor: "bg-red-100 text-red-600",
//     image: "https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=400&h=200&fit=crop",
//     completed: true,
//   },
//   {
//     id: 2,
//     title: "Child Protection Policy",
//     category: "Compliance",
//     lessons: 6,
//     duration: "30 mins",
//     badge: "Mandatory",
//     badgeColor: "bg-red-100 text-red-600",
//     image: "https://images.unsplash.com/photo-1488521787991-ed7bbaae773c?q=80&w=400&h=200&fit=crop",
//     completed: false,
//   },
//   {
//     id: 3,
//     title: "Coaching Standards",
//     category: "Sports & Fitness",
//     lessons: 10,
//     duration: "1h 15m",
//     badge: "Training",
//     badgeColor: "bg-blue-100 text-blue-600",
//     image: "https://images.unsplash.com/photo-1526232759583-26f1735673b2?q=80&w=400&h=200&fit=crop",
//     completed: false,
//   },
//   {
//     id: 4,
//     title: "Communication Skills",
//     category: "Soft Skills",
//     lessons: 12,
//     duration: "2h 10m",
//     badge: "Soft Skills",
//     badgeColor: "bg-purple-100 text-purple-600",
//     image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=400&h=200&fit=crop",
//     completed: false,
//   },
//   {
//     id: 5,
//     title: "Data Privacy & Security",
//     category: "Compliance",
//     lessons: 9,
//     duration: "1h 5m",
//     badge: "Compliance",
//     badgeColor: "bg-orange-100 text-orange-600",
//     image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=400&h=200&fit=crop",
//     completed: false,
//   },
//   {
//     id: 6,
//     title: "Team Management",
//     category: "Management",
//     lessons: 7,
//     duration: "45 mins",
//     badge: "Management",
//     badgeColor: "bg-teal-100 text-teal-600",
//     image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=400&h=200&fit=crop",
//     completed: false,
//   },
//   {
//     id: 7,
//     title: "Fitness & Conditioning Basics",
//     category: "Sports & Fitness",
//     lessons: 8,
//     duration: "50 mins",
//     badge: "Sports & Fitness",
//     badgeColor: "bg-green-100 text-green-600",
//     image: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?q=80&w=400&h=200&fit=crop",
//     completed: false,
//   },
//   {
//     id: 8,
//     title: "Time Management",
//     category: "Soft Skills",
//     lessons: 5,
//     duration: "25 mins",
//     badge: "Soft Skills",
//     badgeColor: "bg-purple-100 text-purple-600",
//     image: "https://images.unsplash.com/photo-1506784983877-45594efa4cbe?q=80&w=400&h=200&fit=crop",
//     completed: false,
//   }
// ];

// const LMSCourseList = () => {
//   const [searchQuery, setSearchQuery] = useState("");

//   const handleAddNewCourse = () => {
//     alert("Redirect to Add New Course Page");
//     // In future: navigate("/courses/add")
//   };

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen">
//       {/* HEADER SECTION */}
//       <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900">Course List</h1>
//         </div>
//         <button
//           onClick={handleAddNewCourse}
//           className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2.5 rounded-lg font-semibold transition shadow-sm"
//         >
//           <Plus size={20} />
//           Add New Course
//         </button>
//       </div>

//       {/* FILTER SECTION */}
//       <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-8">
//         <div className="flex flex-wrap items-end gap-4">
//           {/* Search Box */}
//           <div className="flex-1 min-w-[300px] relative">
//             <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
//             <input
//               type="text"
//               placeholder="Search courses by name or category"
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//               className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
//             />
//           </div>

//           {/* Filters */}
//           {[
//             { label: "Category", options: ["All Categories", "Safety", "Compliance", "Soft Skills"] },
//             { label: "Course Type", options: ["All Types", "Mandatory", "Training"] },
//             { label: "Level", options: ["All Levels", "Beginner", "Intermediate", "Advanced"] },
//             { label: "Language", options: ["All Languages", "English", "Tamil", "Hindi"] },
//           ].map((filter, index) => (
//             <div key={index} className="flex flex-col gap-1.5">
//               <label className="text-xs font-semibold text-gray-500 uppercase tracking-wider">
//                 {filter.label}
//               </label>
//               <select className="border border-gray-200 rounded-lg px-3 py-2 text-sm bg-gray-50 focus:outline-none min-w-[140px]">
//                 {filter.options.map((opt, i) => (
//                   <option key={i} value={opt}>{opt}</option>
//                 ))}
//               </select>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* COURSE GRID */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//         {COURSES_DATA.map((course) => (
//           <div
//             key={course.id}
//             className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md transition-shadow group cursor-pointer"
//           >
//             {/* Image & Badge Container */}
//             <div className="relative h-40 overflow-hidden">
//               <img
//                 src={course.image}
//                 alt={course.title}
//                 className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
//               />
//               <div className={`absolute top-3 left-3 px-2.5 py-1 rounded-md text-[10px] font-bold uppercase tracking-wide ${course.badgeColor}`}>
//                 {course.badge}
//               </div>
//               <div className="absolute top-3 right-3">
//                 {course.completed ? (
//                   <CheckCircle2 size={24} className="text-green-500 fill-white" />
//                 ) : (
//                   <div className="w-5 h-5 rounded-full border-2 border-white bg-black/20" />
//                 )}
//               </div>
//             </div>

//             {/* Content Container */}
//             <div className="p-4">
//               <h3 className="font-bold text-gray-900 text-sm mb-1 line-clamp-1">{course.title}</h3>
//               <p className="text-xs text-gray-500 mb-4">{course.category}</p>

//               <div className="flex items-center gap-4 text-gray-500">
//                 <div className="flex items-center gap-1.5">
//                   <BookOpen size={14} />
//                   <span className="text-[11px]">{course.lessons} Lessons</span>
//                 </div>
//                 <div className="flex items-center gap-1.5">
//                   <Clock size={14} />
//                   <span className="text-[11px]">{course.duration}</span>
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* FOOTER & PAGINATION */}
//       <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4">
//         <p className="text-sm text-gray-500">Showing 1 to 8 of 24 courses</p>
        
//         <div className="flex items-center gap-2">
//           <button className="p-2 border border-gray-200 rounded-lg hover:bg-gray-100 text-gray-400 disabled:opacity-50">
//             <ChevronLeft size={18} />
//           </button>
//           {[1, 2, 3].map((page) => (
//             <button
//               key={page}
//               className={`w-9 h-9 flex items-center justify-center rounded-lg text-sm font-medium transition ${
//                 page === 1 ? "bg-green-700 text-white" : "border border-gray-200 hover:bg-gray-100 text-gray-600"
//               }`}
//             >
//               {page}
//             </button>
//           ))}
//           <button className="p-2 border border-gray-200 rounded-lg hover:bg-gray-100 text-gray-400">
//             <ChevronRight size={18} />
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LMSCourseList;

// import React, { useState, useEffect, useCallback } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import { Search, Plus, BookOpen, Clock, CheckCircle2, Edit, Trash2 } from "lucide-react";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import { toast } from "react-toastify";
// import PageLoader from "../../helpers/PageLoader";

// const LMSCourseList = () => {
//   const { portalName } = useParams();
//   const navigate = useNavigate();
  
//   const [loading, setLoading] = useState(true);
//   const [courses, setCourses] = useState([]);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [filters, setFilters] = useState({ category: "", status: "" });
//   const [pagination, setPagination] = useState({ page: 1, limit: 8, total: 0 });

//   // Fetch all courses from the backend
//   const fetchCourses = useCallback(async () => {
//     try {
//       setLoading(true);
//       const response = await api({
//         ...SummaryApi.getAllLmsCourses,
//         params: {
//           page: pagination.page,
//           limit: pagination.limit,
//           search: searchQuery,
//           category: filters.category,
//           status: filters.status,
//         },
//       });

//       if (response.data.success) {
//         setCourses(response.data.data.courses || []);
//         setPagination(prev => ({ ...prev, total: response.data.data.total }));
//       }
//     } catch (error) {
//       toast.error(error.response?.data?.message || "Failed to fetch courses");
//     } finally {
//       setLoading(false);
//     }
//   }, [pagination.page, pagination.limit, searchQuery, filters]);

//   useEffect(() => {
//     fetchCourses();
//   }, [fetchCourses]);

//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this course?")) return;
//     try {
//       const response = await api({ ...SummaryApi.deleteLmsCourse(id) });
//       if (response.data.success) {
//         toast.success("Course deleted");
//         fetchCourses();
//       }
//     } catch (error) {
//       toast.error("Delete failed");
//     }
//   };

//   return (
//     <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
//       {/* Header Section */}
//       <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
//         <div>
//           <h1 className="text-2xl font-bold text-gray-900">Course Management</h1>
//           <p className="text-sm text-gray-500">Manage and monitor your organization's learning content</p>
//         </div>
//         <button
//           onClick={() => navigate(`/${portalName}/hr/lms-management/courses/create`)}
//           className="flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white px-5 py-2.5 rounded-lg font-semibold transition shadow-md w-full md:w-auto"
//         >
//           <Plus size={20} />
//           Add New Course
//         </button>
//       </div>

//       {/* Filter Section */}
//       <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-8 flex flex-col lg:flex-row gap-4">
//         <div className="flex-1 relative">
//           <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
//           <input
//             type="text"
//             placeholder="Search by name or code..."
//             className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 outline-none text-sm"
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//         </div>
//         <div className="flex flex-wrap gap-3">
//           <select 
//             className="border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white outline-none focus:ring-2 focus:ring-red-500"
//             onChange={(e) => setFilters({ ...filters, category: e.target.value })}
//           >
//             <option value="">All Categories</option>
//             <option value="Safety">Safety</option>
//             <option value="Compliance">Compliance</option>
//           </select>
//           <select 
//             className="border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white outline-none focus:ring-2 focus:ring-red-500"
//             onChange={(e) => setFilters({ ...filters, status: e.target.value })}
//           >
//             <option value="">All Status</option>
//             <option value="Published">Published</option>
//             <option value="Draft">Draft</option>
//           </select>
//         </div>
//       </div>

//       {/* Course Grid */}
//       {loading ? <PageLoader /> : (
//         <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6">
//           {courses.map((course) => (
//             <div key={course._id} className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-lg transition-all group">
//               <div className="relative h-44 overflow-hidden">
//                 <img
//                   src={course.thumbnail?.url || "https://via.placeholder.com/400x200?text=No+Thumbnail"}
//                   alt={course.courseTitle}
//                   className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
//                 />
//                 <div className="absolute top-3 left-3 bg-red-600 text-white px-2 py-1 rounded text-[10px] font-bold uppercase">
//                   {course.status}
//                 </div>
//                 <div className="absolute top-3 right-3 flex gap-2">
//                    <button onClick={() => navigate(`/${portalName}/hr/lms-management/courses/edit/${course._id}`)} className="bg-white/90 p-1.5 rounded-full text-blue-600 hover:bg-white shadow-sm"><Edit size={14}/></button>
//                    <button onClick={() => handleDelete(course._id)} className="bg-white/90 p-1.5 rounded-full text-red-600 hover:bg-white shadow-sm"><Trash2 size={14}/></button>
//                 </div>
//               </div>

//               <div className="p-4">
//                 <div className="flex justify-between items-start mb-1">
//                    <h3 className="font-bold text-gray-900 text-sm line-clamp-1 flex-1">{course.courseTitle}</h3>
//                    {course.status === "Published" && <CheckCircle2 size={16} className="text-red-600 ml-2" />}
//                 </div>
//                 <p className="text-[11px] text-gray-500 mb-3 font-medium uppercase tracking-wider">{course.category}</p>

//                 <div className="flex items-center gap-4 text-gray-500 border-t pt-3">
//                   <div className="flex items-center gap-1.5">
//                     <BookOpen size={14} className="text-red-500" />
//                     <span className="text-[11px]">{course.uploadContent?.length || 0} Contents</span>
//                   </div>
//                   <div className="flex items-center gap-1.5">
//                     <Clock size={14} className="text-red-500" />
//                     <span className="text-[11px]">{course.duration}</span>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default LMSCourseList;

import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Search, Plus, BookOpen, Clock, CheckCircle2, Edit, Trash2, Eye } from "lucide-react";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import { toast } from "react-toastify";
import PageLoader from "../../helpers/PageLoader";
import SelectDropdown from "../../customStyles/SelectDropdown";
import Pagination from "../../helpers/Pagination"; // Ensure correct path

const LMSCourseList = () => {
  const { portalName } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  // URL Params Initialization
  const pageParam = parseInt(searchParams.get("page")) || 1;
  const limitParam = searchParams.get("limit") === "All" ? "All" : parseInt(searchParams.get("limit")) || 9;

  // States
  const [loading, setLoading] = useState(true);
  const [courses, setCourses] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [dataCache, setDataCache] = useState({});
  
  const [filters, setFilters] = useState({ category: "", status: "" });
  
  const [pagination, setPagination] = useState({
    total: 0,
    page: pageParam,
    limit: limitParam,
  });

  // Dropdown Options
  const categoryOptions = [
    { id: "Safety", label: "Safety" },
    { id: "Compliance", label: "Compliance" },
    { id: "Management", label: "Management" },
    { id: "Soft Skills", label: "Soft Skills" },
    { id: "Coaching", label: "Coaching" }
  ];

  const statusOptions = [
    { id: "Published", label: "Published" },
    { id: "Draft", label: "Draft" }
  ];

  /* ================= NAVIGATION & URL HELPERS ================= */

  const updateURL = (newPage, newLimit) => {
    const params = {};
    if (newPage) params.page = newPage;
    if (newLimit) params.limit = newLimit;
    setSearchParams(params);
  };

  /* ================= SEARCH DEBOUNCE ================= */

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 600);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  /* ================= API FETCHING WITH CACHE ================= */

  const generateCacheKey = useCallback(() => {
    return JSON.stringify({
      page: pagination.page,
      limit: pagination.limit,
      search: debouncedSearch,
      filters
    });
  }, [pagination.page, pagination.limit, debouncedSearch, filters]);

  const fetchCourses = useCallback(async (forceRefresh = false) => {
    const cacheKey = generateCacheKey();

    // Use Cache if not forcing refresh
    if (!forceRefresh && dataCache[cacheKey]) {
      setCourses(dataCache[cacheKey].data);
      setPagination(prev => ({ ...prev, total: dataCache[cacheKey].total }));
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await api({
        ...SummaryApi.getAllLmsCourses,
        params: {
          page: pagination.page,
          limit: pagination.limit,
          search: debouncedSearch,
          category: filters.category,
          status: filters.status,
        },
      });

      if (response.data.success) {
        const fetchedData = response.data.data.courses || [];
        const fetchedTotal = response.data.data.total || 0;
        
        setCourses(fetchedData);
        setPagination(prev => ({ ...prev, total: fetchedTotal }));

        // Store in Cache
        setDataCache(prev => ({
          ...prev,
          [cacheKey]: { data: fetchedData, total: fetchedTotal }
        }));
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to fetch courses");
    } finally {
      setLoading(false);
    }
  }, [pagination.page, pagination.limit, debouncedSearch, filters, dataCache, generateCacheKey]);

  useEffect(() => {
    fetchCourses();
  }, [fetchCourses]);

  /* ================= HANDLERS ================= */

  const handlePageChange = (newPage) => {
    setPagination(prev => ({ ...prev, page: newPage }));
    updateURL(newPage, pagination.limit);
  };

  const handleLimitChange = (newLimit) => {
    setPagination(prev => ({ ...prev, page: 1, limit: newLimit }));
    updateURL(1, newLimit);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this course?")) return;
    try {
      const response = await api({
        url: SummaryApi.deleteLmsCourse.url(id),
        method: SummaryApi.deleteLmsCourse.method
      });
      if (response.data.success) {
        toast.success("Course deleted successfully");
        setDataCache({}); // Invalidate Cache
        fetchCourses(true);
      }
    } catch (error) {
      toast.error("Failed to delete course");
    }
  };

  return (
    <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
      {/* Header Section */}
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Course Management</h1>
          <p className="text-sm text-gray-500">Create, manage and monitor your learning modules</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
          <button
            onClick={() => navigate(`/${portalName}/hr/lms-management/courses/assign/create`)}
            className="flex items-center justify-center gap-2 border-2 border-red-600 text-red-600 hover:bg-red-50 px-5 py-2.5 rounded-lg font-bold transition shadow-sm w-full md:w-auto"
          >
            <Plus size={20} /> Assign
          </button>

          <button
            onClick={() => navigate(`/${portalName}/hr/lms-management/courses/create`)}
            className="flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white px-5 py-2.5 rounded-lg font-bold transition shadow-md w-full md:w-auto"
          >
            <Plus size={20} /> Add New
          </button>
        </div>
      </div>

      {/* Filter Section */}
      <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-100 mb-8 flex flex-col lg:flex-row gap-4 items-end">
        <div className="flex-1 relative w-full">
          <label className="block text-xs font-bold text-gray-400 uppercase mb-1">Search</label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
            <input
              type="text"
              placeholder="Filter by title or course code..."
              className="w-full pl-10 pr-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-red-500 outline-none text-sm"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setPagination(prev => ({ ...prev, page: 1 }));
              }}
            />
          </div>
        </div>

        <div className="w-full lg:w-64">
          <label className="block text-xs font-bold text-gray-400 uppercase mb-1">Category</label>
          <SelectDropdown
            options={categoryOptions}
            value={filters.category}
            onChange={(val) => {
              setFilters(prev => ({ ...prev, category: val }));
              setPagination(prev => ({ ...prev, page: 1 }));
            }}
            placeholder="All Categories"
            ChildClassName="h-[40px]"
          />
        </div>

        <div className="w-full lg:w-48">
          <label className="block text-xs font-bold text-gray-400 uppercase mb-1">Status</label>
          <SelectDropdown
            options={statusOptions}
            value={filters.status}
            onChange={(val) => {
              setFilters(prev => ({ ...prev, status: val }));
              setPagination(prev => ({ ...prev, page: 1 }));
            }}
            placeholder="All Status"
            ChildClassName="h-[40px]"
          />
        </div>
      </div>

      {/* Main Content Area */}
      {loading ? <PageLoader /> : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6">
            {courses.length > 0 ? (
              courses.map((course) => (
                <div key={course._id} className="bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-lg transition-all group flex flex-col h-full">
                  <div className="relative h-44 overflow-hidden shrink-0">
                    <img
                      src={course.thumbnail?.url || "https://via.placeholder.com/400x200?text=LMS+Course"}
                      alt={course.courseTitle}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className={`absolute top-3 left-3 px-2 py-1 rounded text-[10px] font-bold uppercase shadow-sm ${course.status === 'Published' ? 'bg-green-600 text-white' : 'bg-yellow-500 text-white'}`}>
                      {course.status}
                    </div>
                    <div className="absolute top-3 right-3 flex gap-2">
                       <button onClick={() => navigate(`/${portalName}/hr/lms-management/courses/view/${course._id}`)} className="bg-white/90 p-1.5 rounded-full text-gray-600 hover:bg-white shadow-sm transition-colors"><Eye size={14}/></button>
                       <button onClick={() => navigate(`/${portalName}/hr/lms-management/courses/edit/${course._id}`)} className="bg-white/90 p-1.5 rounded-full text-blue-600 hover:bg-white shadow-sm transition-colors"><Edit size={14}/></button>
                       <button onClick={() => handleDelete(course._id)} className="bg-white/90 p-1.5 rounded-full text-red-600 hover:bg-white shadow-sm transition-colors"><Trash2 size={14}/></button>
                    </div>
                  </div>

                  <div className="p-4 flex flex-col flex-1">
                    <div className="flex justify-between items-start gap-2 mb-1">
                        <h3 className="font-bold text-gray-900 text-sm line-clamp-1">{course.courseTitle}</h3>
                        {course.status === "Published" && <CheckCircle2 size={14} className="text-red-600 shrink-0 mt-0.5" />}
                    </div>
                    <p className="text-[11px] text-gray-400 mb-4 font-semibold uppercase tracking-wider">{course.category}</p>

                    <div className="mt-auto flex items-center gap-4 text-gray-500 border-t pt-3">
                      <div className="flex items-center gap-1.5">
                        <BookOpen size={14} className="text-red-500" />
                        <span className="text-[11px] font-medium">{course.uploadContent?.length || 0} Lessons</span>
                      </div>
                      <div className="flex items-center gap-1.5">
                        <Clock size={14} className="text-red-500" />
                        <span className="text-[11px] font-medium">{course.duration}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-full py-24 text-center bg-white rounded-2xl border border-dashed border-gray-200">
                <div className="flex flex-col items-center gap-2">
                    <Search size={40} className="text-gray-200" />
                    <p className="text-gray-400 font-medium">No courses found matching your criteria</p>
                    <button onClick={() => { setSearchQuery(""); setFilters({category: "", status: ""}); }} className="text-red-600 text-sm font-bold underline mt-2">Clear all filters</button>
                </div>
              </div>
            )}
          </div>

          {/* Pagination Integration */}
          {courses.length > 0 && (
            <div className="mt-10 mb-6 bg-white p-4 rounded-xl shadow-sm border border-gray-100">
                <Pagination
                    totalItems={pagination.total}
                    itemsPerPage={pagination.limit}
                    currentPage={pagination.page}
                    onPageChange={handlePageChange}
                    onItemsPerPageChange={handleLimitChange}
                />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default LMSCourseList;